import React from "react";
import Header from "../Header/Header";
// import { useList } from "../../customHooks/hooks";
import { ChildrenContainer, WrapperGeneral } from "./Style";

const MasterPagePeru = ({ children }) => {
  return (
    <WrapperGeneral>
      <Header />
      <ChildrenContainer>{children}</ChildrenContainer>
    </WrapperGeneral>
  );
};

export default MasterPagePeru;
